export default __webpack_public_path__ + "static/media/basic.950f88a9.svg";